/**
 * Reiter „Positionen" der Container-Schublade (REQ-27 §2.2): die Bestellpositionen des
 * Containers, nur lesend.
 *
 * Die Spaltenüberschriften kommen aus `getCaption` und sind damit dieselben wie im Grid der
 * Bestellpositionen — sie bleiben englisch („Item Number", „Date of Delivery").
 */

import { getCaption } from '@/types/captions';
import type { OrderPosition } from '@/types/entities';
import { EntityTypes } from '@/types/enums';
import { formatDate } from '@/utils/date';
import { formatNumber } from '@/utils/number';

import { RelatedListState } from './RelatedListState';
import type { RelatedList } from './useRelatedList';

export interface ContainerPositionsProps {
  list: RelatedList<OrderPosition>;
}

const caption = (field: string): string => getCaption(EntityTypes.Bestellposition, field);

export function ContainerPositions(props: ContainerPositionsProps) {
  return (
    <RelatedListState
      list={props.list}
      emptyText="Diesem Container ist keine Position zugeordnet."
      emptyIconClass="fa-solid fa-boxes-stacked"
    >
      <table className="iwm-entity-table">
        <thead>
          <tr>
            <th scope="col">{caption('Order')}</th>
            <th scope="col">{caption('Artikelnummer')}</th>
            <th scope="col">{caption('Bezeichnung1')}</th>
            <th scope="col" className="iwm-entity-table-numeric">
              {caption('Menge')}
            </th>
            <th scope="col">{caption('Liefertermin')}</th>
          </tr>
        </thead>
        <tbody>
          {props.list.items.map((position) => (
            <tr key={position.Id}>
              <td>{position.Order}</td>
              <td>{position.Artikelnummer}</td>
              <td>{position.Bezeichnung1}</td>
              <td className="iwm-entity-table-numeric">{formatNumber(position.Menge, 'N0')}</td>
              <td className="iwm-entity-table-value">{formatDate(position.Liefertermin)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </RelatedListState>
  );
}

export default ContainerPositions;
